import React, { useState, useContext, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button, List, ListItem, ListItemText, Paper, TextField, Typography } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { UsersContext } from '../../../context/users-context';
import { AllEquipsContext } from '../../../context/allEquips-context';
import * as ServiceWorker from '../../../workers/serviceWorker'

const useStyles = makeStyles((theme) => ({
    root: {
		height: "calc(100vh - 64px - 48px)",
		display: "flex",
		flexDirection: "row",
		gap: 10,
	},
	searchAndFiltration: {
		display: "flex",
		flexDirection: "column",
		flex: "0 0 300px",
		gap: 10,
	},
	search: {
		display: "flex",
		flexDirection: "column",
		justifyContent: "space-between",
		padding: "10px",
		height: "300px",
	},
	result: {
		display: "flex",
		flexDirection: "row",
		flex: "1",
		gap: 10,
	},
	textField: {
		width: 200,
	},
	commonSpacing: {
		marginLeft: theme.spacing(1),
		marginRight: theme.spacing(1),
	}
}));

const getDate = (date, daysOffset = 0) => {
    var res = new Date(date);
    if (daysOffset !== 0)
        res.setDate(res.getDate() + daysOffset);
    return res.toISOString().split("T")[0];
};
const parseLocalString = (value) => value ? new Date(value).toLocaleString(navigator.language) : value;

export default function EquipsServiceTabPanel(props) {
    console.log("render EquipsServiceTabPanel");

    const classes = useStyles();
	const [usersState, usersDispatch] = useContext(UsersContext);
    const [allEquipsState, allEquipsDispatch] = useContext(AllEquipsContext);
    const curDate = getDate(new Date());
    const maxEndDate = getDate(new Date(), 7);

	const [complexSN, setComplexSN] = useState(null);
    const [startDate, setStartDate] = useState(curDate);
    const [endDate, setEndDate] = useState(curDate);
    const [complexSNWarn, setComplexSNWarn] = useState(false);
    const [startDateError, setStartDateError] = useState(false);
    const [endDateError, setEndDateError] = useState(false);
	const [displayingComplexSN, setDisplayingComplexSN] = useState('');
    const [displayingStartDate, setDisplayingStartDate] = useState(curDate);
	const [displayingEndDate, setDisplayingEndDate] = useState(curDate);
    const [pwd, setPwd] = useState('');
    
	const token = usersState.token;
    const allEquips = allEquipsState.allEquips;

	const handleSNChange = (ev, value) => {
		setComplexSN(value);
        setComplexSNWarn(value?.startsWith(' ') || value?.endsWith(' '));
	};

    const handleStartDateChange = (ev) => {
        if (ev.target.value !== '')
            setStartDate(ev.target.value);
	};

	const handleEndDateChange = (ev) => {
        if (ev.target.value !== '')
            setEndDate(ev.target.value);
	};

    const onGenerate = async () => {
        await ServiceWorker.GetPassword(token, complexSN ?? '', startDate, endDate).then((res) => {
            setPwd(res);
        });
        setDisplayingComplexSN(complexSN ?? '');
        setDisplayingStartDate(startDate);
        setDisplayingEndDate(endDate);
    };

    useEffect(() => {
        setStartDateError(startDate < curDate || startDate > endDate);
        setEndDateError(endDate < curDate || endDate > maxEndDate);
    }, [startDate, endDate])

    return (
        <div className={classes.root}>
            <div className={classes.searchAndFiltration}>
                <Paper className={classes.search}>
                    <Typography>Пароль для входа в Atlas</Typography>
                    <Autocomplete
                        id="snSelect"
                        freeSolo
                        defaultValue={complexSN}
                        options={[...new Set(allEquips?.map((equip) => (equip.SerialNumber)).sort())]}
                        renderInput={(params) => 
                        <TextField {...params}
                            label="Серийный номер комплекса"
                            helperText={complexSNWarn ? "Проверьте пробелы" : ""}
                            FormHelperTextProps={{ style: { color: 'coral' } }}
                        />}
                        onChange={handleSNChange}
                        onInputChange={handleSNChange}
						className={(classes.textField, classes.commonSpacing)}
                    />
					<TextField
						id="startDate"
						label="Начальная дата"
						type="date"
						defaultValue={startDate}
                        InputProps={{inputProps: { min: curDate, max: maxEndDate }}}
						onChange={handleStartDateChange}
                        error={startDateError}
						className={(classes.textField, classes.commonSpacing)}
						InputLabelProps={{
							shrink: true,
						}}
					/>
					<TextField
						id="endDate"
						label="Конечная дата"
						type="date"
						defaultValue={endDate}
                        InputProps={{inputProps: { min: startDate, max: maxEndDate }}}
						onChange={handleEndDateChange}
                        error={endDateError}
						className={(classes.textField, classes.commonSpacing)}
						InputLabelProps={{
							shrink: true,
						}}
					/>
                    <Typography align='left' style={{color:"orange"}} className={(classes.commonSpacing)}>Выдача пароля логируется</Typography>
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.commonSpacing}
                        onClick={onGenerate}
                        disabled={!(startDate && endDate) || startDateError || endDateError}>
                        Получить
					</Button>
                </Paper>
            </div>
            <div className={classes.result}>
                <Paper style={{width: "100%"}}>
                    <Typography component="span" variant="h5" color="textPrimary">
                            {`Пароли для комплекса '${displayingComplexSN}' с ${parseLocalString(displayingStartDate).split(",")[0]} по ${parseLocalString(displayingEndDate).split(",")[0]}`}
                    </Typography>
                    <List>
                        {pwd?.split('\n').map((text, index) => (
                        <ListItem key={`pwd${index}`}>
                            <ListItemText primary={text}/>
                        </ListItem>))}
                    </List>
                </Paper>
            </div>
        </div>
      );
}